import React from 'react';
import { Trophy } from 'lucide-react';

const Cell = ({ value, win }) => (
  <td className={`px-4 py-4 text-sm align-top ${win ? 'font-semibold text-[#3a190b]' : 'text-[#202020]/80'}`}>
    <span className="inline-flex items-start gap-1.5">
      {win && <Trophy className="h-4 w-4 mt-0.5 text-amber-500 flex-shrink-0" aria-label="beste keuze" />}
      {value}
    </span>
  </td>
);

const CriteriaTable = ({ criteria, a, b }) => {
  const scoreA = criteria.filter((c) => c.winner === 'a').length;
  const scoreB = criteria.filter((c) => c.winner === 'b').length;
  return (
    <section className="py-12 md:py-16 bg-[#faf7f5]" data-testid="criteria-table-section">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#202020] mb-2">Vergelijking per criterium</h2>
        <p className="text-sm text-[#202020]/60 mb-8">Score: {a.name} {scoreA} — {scoreB} {b.name} (gelijkspel niet meegeteld)</p>
        <div className="overflow-x-auto rounded-2xl border border-[#3a190b]/10 bg-white shadow-sm">
          <table className="w-full text-left border-collapse" data-testid="criteria-table">
            <thead>
              <tr className="bg-[#3a190b] text-white">
                <th className="px-4 py-4 text-xs uppercase tracking-wider font-semibold w-1/3">Criterium</th>
                <th className="px-4 py-4 text-xs uppercase tracking-wider font-semibold">{a.name}</th>
                <th className="px-4 py-4 text-xs uppercase tracking-wider font-semibold">{b.name}</th>
              </tr>
            </thead>
            <tbody>
              {criteria.map((row, i) => (
                <tr key={row.label} className={i % 2 ? 'bg-[#faf7f5]/60' : 'bg-white'} data-testid={`criteria-row-${i}`}>
                  <th scope="row" className="px-4 py-4 text-sm font-medium text-[#202020]">{row.label}</th>
                  <Cell value={row.a} win={row.winner === 'a'} />
                  <Cell value={row.b} win={row.winner === 'b'} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default CriteriaTable;
